var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dropdown-item",class:{ disabled: _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('div',[_vm._t("default")],2),(_vm.icon)?_c('em',{staticClass:"ml-1 fas",class:_vm.icon}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }